export const AD_URL_PREFIX = '/gubi'
export const MOBILE_URL =
  'https://webapp-ai.61info.cn/ai_course_pay_h5_view/web/experience-v7?channelId=55259'
